import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BankDetails } from 'src/app/models/bank-details';
import { BankValidators } from 'src/app/validators/bank-validators';

@Component({
  selector: 'bank-details-form',
  templateUrl: './bank-details-form.component.html',
  styleUrls: ['./bank-details-form.component.scss']
})
export class BankDetailsFormComponent implements OnChanges {
  @Input() data: BankDetails;
  @Output() confirm = new EventEmitter<BankDetails>();

  form = this.fb.group({
    bankName: ['', BankValidators.bankName()],
    iban: ['', BankValidators.IBAN()],
    accountNumber: ['', BankValidators.accountNumber()],
    swiftCode: ['', BankValidators.swiftCode()],
    branchName: ['', BankValidators.branchName()],
    branchAddress: ['', BankValidators.branchAddress()],
    accountHolderLegalName: ['', BankValidators.accountHolder()]
  });

  withIban = true;

  error: string = null;

  constructor(private fb: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data?.currentValue?.accountHolderLegalName !== changes.data?.previousValue?.accountHolderLegalName) {
      this.fillForm(changes.data?.currentValue);
    }
  }

  fillForm(data: BankDetails) {
    if (!data) {
      return;
    }

    this.form.patchValue({
      bankName: data.bankName,
      iban: data.iban,
      accountNumber: data.accountNumber,
      swiftCode: data.swiftCode,
      branchName: data.branchName,
      branchAddress: data.branchAddress,
      accountHolderLegalName: data.accountHolderLegalName
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.confirm.emit(this.form.value);
    } else {
      this.error = 'Please fill out the required fields';
    }
  }

  switchIban() {
    this.withIban = !this.withIban;
    this.setIbanValidators();
  }

  setIbanValidators() {
    if (this.withIban) {
      this.iban.setValidators(BankValidators.IBAN());
    } else {
      this.iban.setValue(null);
      this.iban.clearValidators();
    }

    this.iban.updateValueAndValidity();
  }

  get iban() {
    return this.form.get('iban');
  }
}
